function n(e) {
  return `${e}?ReferUrl=${encodeURIComponent(
    window.location.href
  )}`;
}
export {
  n as createMyAccountLink
};
//# sourceMappingURL=index2.js.map
